import React from "react";
import { useNavigate } from "react-router-dom";
import { AuthLayout } from "../../../components/layouts/AuthLayout";
import { SignupForm } from "../../../components/features/Authentication/SignupForm";
import { SignupPageProps } from "./SignupPage.types";

export const SignupPage: React.FC<SignupPageProps> = () => {
  const navigate = useNavigate();

  const handleRegistrationSuccess = (userData: any) => {
    console.log("User registered successfully:", userData);
    // TODO: Redirect to dashboard, welcome page, or login page
    // For now, redirect to signin page to let user log in
    navigate("/account/signin");
  };

  const handleNavigateToSignin = () => {
    navigate("/account/signin");
  };

  return (
    <AuthLayout
      title="Create Account"
      subtitle="Join FormSubmits to manage your venues digital signage"
    >
      <SignupForm
        onRegistrationSuccess={handleRegistrationSuccess}
        onNavigateToSignin={handleNavigateToSignin}
      />
    </AuthLayout>
  );
};
